import { getApiUrl } from "./api";
/**
 * Get avatar URL with fallback
 * @param {string|null|undefined} avatar - Avatar path or URL
 * @returns {string} Avatar URL or default avatar
 */
export const DEFAULT_AVATAR_DATA_URL =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='%23111827'/%3E%3Cpath fill='%23ffffff' d='M50 52c10.493 0 19-8.507 19-19S60.493 14 50 14 31 22.507 31 33s8.507 19 19 19Zm0 6c-15.464 0-28 12.536-28 28v2h56v-2c0-15.464-12.536-28-28-28Z'/%3E%3C/svg%3E";

export const getAvatarUrl = (avatar) => {
  // If no avatar or empty string, return default
  if (!avatar || typeof avatar !== "string" || !avatar.trim()) {
    return DEFAULT_AVATAR_DATA_URL;
  }
  
  // Don't use Google/external URLs - only use uploaded avatars
  // If it's a full URL (Google OAuth or external source), use default instead
  if (avatar.startsWith("http://") || avatar.startsWith("https://")) {
    return DEFAULT_AVATAR_DATA_URL;
  }
  
  // Otherwise, treat it as a local file from uploads
  return getApiUrl(`/uploads/${avatar}`);
};

/**
 * Get default avatar URL
 * @returns {string} Default avatar URL
 */
export const getDefaultAvatar = () => {
  return DEFAULT_AVATAR_DATA_URL;
};

/**
 * SVG data URL for ultimate fallback (gray circle)
 */
export const FALLBACK_AVATAR_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Ccircle cx='50' cy='50' r='50' fill='%23d1d5db'/%3E%3C/svg%3E";

export const getPoemImageUrl = (coverImage) => {
  if (!coverImage || typeof coverImage !== "string" || !coverImage.trim()) {
    return null;
  }
  if (coverImage.startsWith("http://") || coverImage.startsWith("https://")) {
    return coverImage;
  }
  return getApiUrl(`/uploads/${coverImage}`);
};

